export default __webpack_public_path__ + "static/cantali-bisiklet-11eaf4fce9ad27c5f6d39981198d4524.png";